import { all } from 'redux-saga/effects';
import InterviewSaga from './interviewSaga';
import MeetSaga from './meetSaga';
export default function* rootSaga() {
    yield all([InterviewSaga(), MeetSaga()]);
}
